// Omslag (adım 3) sayfa bazında kapatılabilir. page.custom-macrons.liquid
// içindeki cmb_omslag_enabled bayrağı window.CMB_OMSLAG_ENABLED olarak basılır.
// Bayrak tanımlı değilse (eski/legacy sayfalar) omslag açık kalır.
var CMB_OMSLAG_OFF = (window.CMB_OMSLAG_ENABLED === false);

$(document).ready(function() {

    var _prevBoxVariantId = '';
    var _summaryReached   = false;
    var _boxQty           = 1;   // firmagave'de + basılınca set edilir, normal sayfada 1 sabit
    var _minQtyGlobal     = parseInt($('#step1').attr('data-minqty')) || 0;
    var _currentStep      = 1;
    var _omslagEnabled    = !CMB_OMSLAG_OFF; // hverdag (tray) seçilince false → Omslag adımı atlanır
    var _postnummerOk     = false; // gaveeske için Oslo posta kodu doğrulandı mı
    var _pnPulseShown     = false; // "Sjekk postnummer" pulse vurgusu bu episode'da oynatıldı mı

    // TEST: Oslo aralığı 0120–0130 (canlıda gerçek liste ile değiştirilecek)
    function isOsloPostnummer(pn) {
        var n = parseInt(pn, 10);
        return n >= 120 && n <= 130;
    }

    // ── Step 3 preview cache ──────────────────────────────────────
    var _previewCache = {};

    function _getCoverMediaItem(handle) {
        var media = _previewCache[handle];
        if (!media || !media.length) return null;
        var spaces = parseInt($('#step1').attr('data-productbundlespace')) || 0;
        var idx = spaces >= 18 ? 2 : spaces >= 12 ? 1 : 0;
        return media[idx] || media[idx - 1] || media[0] || null;
    }
    function showStep3Preview(handle, fallbackSrc) {
        var item = _getCoverMediaItem(handle);
        if (item && item.url) {
            if (item.type === 'video') {
                showStep3Video(item.url);
            } else {
                $('#step3-preview-video').hide();
                $('#step3-preview-img').attr('src', item.url).show();
                $('.step3-preview-placeholder').hide();
            }
        } else if (fallbackSrc) {
            $('#step3-preview-video').hide();
            $('#step3-preview-img').attr('src', fallbackSrc).show();
            $('.step3-preview-placeholder').hide();
        }
    }
    function showStep3Video(url) {
        var $v = $('#step3-preview-video');
        if ($v.attr('src') !== url) { $v.attr('src', url); $v[0] && $v[0].load(); }
        $v.show();
        $('#step3-preview-img').hide();
        $('.step3-preview-placeholder').hide();
    }
    function clearStep3Preview() {
        $('#step3-preview-img').attr('src', '').hide();
        var $v = $('#step3-preview-video');
        $v.attr('src', '').hide();
        if ($v[0]) $v[0].pause();
        $('.step3-preview-placeholder').show();
    }
    function getSelectedCoverVideoUrl() {
        var $sel = $('.cover-box.selected-cover-box');
        if (!$sel.length) return '';
        var handle = $sel.data('handle') || '';
        var item = _getCoverMediaItem(handle);
        return (item && item.type === 'video') ? item.url : '';
    }
    function showOmslagPreviewBtn() {
        if (window.innerWidth <= 767) {
            $('#cmb-footer-omslag-preview').css('display', 'flex');
            var $btn = $('#cmb-se-omslag-btn');
            $btn.removeClass('omslag-btn--flash');
            void $btn[0].offsetWidth;
            $btn.addClass('omslag-btn--flash');
            setTimeout(function() { $btn.removeClass('omslag-btn--flash'); }, 3300);
        }
    }
    function hideOmslagPreviewBtn() { $('#cmb-footer-omslag-preview').hide(); }
    function openOmslagSheet() {
        var name = $('.selected-cover-box .step3-title').text() || '';
        var videoUrl = getSelectedCoverVideoUrl();
        if (videoUrl) {
            var $sv = $('#cmb-omslag-sheet-video');
            var sv = $sv[0];
            if ($sv.attr('src') !== videoUrl) { $sv.attr('src', videoUrl); sv && sv.load(); }
            $sv.show();
            $('#cmb-omslag-sheet-img').hide();
            if (sv) sv.play();
        } else {
            var src = $('#step3-preview-img').attr('src') || '';
            $('#cmb-omslag-sheet-img').attr('src', src).show();
            $('#cmb-omslag-sheet-video').hide();
        }
        $('#cmb-omslag-sheet-name').text(name);
        $('#cmb-omslag-sheet-overlay, #cmb-omslag-sheet').addClass('open');
    }
    function closeOmslagSheet() {
        $('#cmb-omslag-sheet-overlay, #cmb-omslag-sheet').removeClass('open');
        var v = $('#cmb-omslag-sheet-video')[0];
        if (v) v.pause();
    }
    $('#cmb-se-omslag-btn').on('click', openOmslagSheet);
    $('#cmb-omslag-sheet-close, #cmb-omslag-sheet-overlay').on('click', closeOmslagSheet);

    // ── Tab state ─────────────────────────────────────────────────
    function setActiveTab(active) {
        $('.cmb-tab').each(function() {
            var s = parseInt($(this).data('step'));
            $(this).removeClass('cmb-tab--active cmb-tab--done');
            if (active > 6) {
                $(this).addClass('cmb-tab--done');
            } else if (s === active) {
                $(this).addClass('cmb-tab--active');
            } else if (s < active) {
                $(this).addClass('cmb-tab--done');
            } else {
                if (s === 6) {
                    if (_summaryReached) $(this).addClass('cmb-tab--done');
                } else {
                    var $sum = $('#step' + s + '-summary');
                    if ($sum.length && $.trim($sum.html()) !== '') {
                        $(this).addClass('cmb-tab--done');
                    }
                }
            }
        });
    }

    // ── Footer back button ────────────────────────────────────────
    var _backTargets = { 2: 1, 3: 2, 4: 3, 5: 4, 6: 5 };
    var _skipHistoryPush = false;
    // hverdag (tray): Omslag (adım 3) atlanır → 4. adımdan geri 2'ye döner
    function prevStepOf(n) {
        if (n === 4 && !_omslagEnabled) return 2;
        return _backTargets[n];
    }
    // Omslag tab'ını (ve onu izleyen bağlantı çizgisini) göster/gizle
    // Görünen tab numaralarını sıraya sok (data-step değişmez, sadece gösterilen rakam)
    // hverdag'da Omslag gizli → 1,2,4,5,6 yerine 1,2,3,4,5 görünür
    function renumberTabs() {
        var n = 0;
        $('.cmb-tab').each(function () {
            if (!_omslagEnabled && parseInt($(this).data('step')) === 3) return;
            n++;
            $(this).find('.cmb-tab-num').text(n);
        });
    }
    function setOmslagEnabled(on) {
        // Sayfa genelinde kapalıysa hiçbir seçim adımı geri açamaz
        _omslagEnabled = CMB_OMSLAG_OFF ? false : !!on;
        var $tab = $('.cmb-tab[data-step="3"]');
        if (_omslagEnabled) { $tab.show().next('.cmb-tab-line').show(); }
        else { $tab.hide().next('.cmb-tab-line').hide(); }
        renumberTabs();
    }
    function updateFooterBackBtn(n) {
        var $btn = $('#cmb-footer-back-btn');
        var target = prevStepOf(n);
        if (window.innerWidth >= 641 && n > 1 && target !== undefined) {
            $btn.data('target', target).show();
        } else {
            $btn.hide();
        }
    }
    $(document).on('click', '#cmb-footer-back-btn', function() {
        window.editStep(parseInt($(this).data('target')));
    });

    // ── Show only one step ────────────────────────────────────────
    function showOnlyStep(n) {
        _currentStep = n;
        if (!_skipHistoryPush) history.pushState({ wizard: true }, '');
        $('#step1, #step2, #step3, #step4, #gift-message-div').hide();
        $('#gift-price-summary, #add-to-card-div').hide();
        if (n === 6) {
            _summaryReached = true;
            $('#gift-price-summary').show();
            $('#add-to-card-div').show();
            updateFooterBackBtn(6);
            $('#cmb-footer-next-btn').hide();
            $('#cmb-footer-bar').show();
            renderMacronSummary();
        } else {
            if (n === 1) $('#step1').show();
            else if (n === 2) { $('#step2').show(); ftrMacronsShow(); updateFtrMacronStrip(); }
            else if (n === 3) $('#step3').show();
            else if (n === 4) $('#step4').show();
            else if (n === 5) $('#gift-message-div').show();
            if (n !== 2) ftrMacronsHide();
            if (n !== 3) hideOmslagPreviewBtn();
            $('#cmb-footer-next-btn').show();
            updateFooterBackBtn(n);
            updateFooterBtn(n);
            $('#cmb-footer-bar').show();
        }
        var tabTop = $('#cmb-tabs').offset().top;
        $('html, body').stop().animate({ scrollTop: Math.max(0, tabTop - 90) }, 300);
    }

    // ── Footer: button label / state ──────────────────────────────
    function updateFooterBtn(step) {
        var $btn = $('#cmb-footer-next-btn');


        if (step === 1) {
            var $sel   = $('.step1-child.selected');
            var hasSel = $sel.length > 0;
            var qtyOk  = _minQtyGlobal === 0 || _boxQty >= _minQtyGlobal;
            var isGave = hasSel && $sel.attr('data-no-omslag') !== '1';
            var needsPost = isGave && !_postnummerOk; // gaveeske: önce Oslo postnummer kontrolü
            $btn.text(needsPost ? 'Sjekk postnummer →' : 'Neste →').prop('disabled', !hasSel || !qtyOk);
            // Buton "Sjekk postnummer" durumuna ilk geçtiğinde tek seferlik pulse (kutu değiştirince tekrarlamaz)
            if (needsPost && hasSel && qtyOk) {
                if (!_pnPulseShown) {
                    _pnPulseShown = true;
                    $btn.removeClass('cmb-btn-pulse');
                    void $btn[0].offsetWidth; // reflow → animasyonu garanti başlat
                    $btn.addClass('cmb-btn-pulse');
                }
            } else {
                _pnPulseShown = false;
                $btn.removeClass('cmb-btn-pulse');
            }

        } else if (step === 2) {
            var tQty = parseInt($('.step2-c').attr('data-totalqty')) || 0;
            var max  = parseInt($('#step1').attr('data-productbundlespace')) || 0;
            $btn.prop('disabled', tQty < max);
            $btn.text('Neste →');

        } else if (step === 3) {
            var hasCover = $('.cover-box.selected-cover-box').length > 0;
            $btn.prop('disabled', false);
            if (hasCover) {
                $btn.text('Neste →');
            } else {
                $btn.text('Fortsett uten omslag');
            }

        } else if (step === 4) {
            var hasCard = $('.greeting-card.selected-card-box').length > 0;
            $btn.prop('disabled', false);
            if (hasCard) {
                $btn.text('Neste →');
            } else {
                $btn.text('Fortsett uten kort');
            }

        } else if (step === 5) {
            var hasMsg = $.trim($('#gift-message').val()) !== '';
            $btn.prop('disabled', false);
            $btn.text(hasMsg ? ('Bekreft og fullfør') : 'Fortsett uten melding');
        }
    }

    // ── Step summary builders (state tracking — hidden via CSS) ───
    function showStep1Summary() {
        var img   = $('.step1-child.selected').attr('data-image') || '';
        var title = $('#step1').attr('data-bundleproducttitle') || '';
        var price = $('#step1').attr('data-bundleproductprice') || '';
        $('#step1-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">1</span>'
            + (img ? '<div class="cmb-sum-media"><img class="cmb-sum-img" src="' + img + '" alt=""></div>' : '')
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + title + '</p><p class="cmb-sum-price">' + price + ',-</p></div>'
            + '</div>'
        );
    }
    function showStep2Summary() {
        var imgs = [];
        $('.macron-temp-div img').each(function() { if (imgs.length < 10) imgs.push($(this).attr('src')); });
        var count = parseInt($('.step2-c').attr('data-totalqty')) || 0;
        $('#step2-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">2</span>'
            + '<div class="cmb-sum-macrons">' + imgs.map(function(s) { return '<img class="cmb-sum-macron" src="' + s + '" alt="">'; }).join('') + '</div>'
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + count + ' makroner valgt</p></div>'
            + '</div>'
        );
    }
    function showStep3Summary(title, img) {
        $('#step3-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">3</span>'
            + (img ? '<div class="cmb-sum-media"><img class="cmb-sum-img" src="' + img + '" alt=""></div>' : '')
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + title + '</p></div>'
            + '</div>'
        );
    }
    function showStep4Summary(title, img) {
        $('#step4-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">4</span>'
            + (img ? '<div class="cmb-sum-media"><img class="cmb-sum-img" src="' + img + '" alt=""></div>' : '')
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + title + '</p></div>'
            + '</div>'
        );
    }
    function showStep5Summary(title) {
        $('#step5-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">5</span>'
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + title + '</p></div>'
            + '</div>'
        );
    }
    function resetSummariesFrom(step) {
        for (var i = step; i <= 5; i++) $('#step' + i + '-summary').html('');
        if (step <= 2) _summaryReached = false;
    }

    // ── Tab click: navigate to a completed step ───────────────────
    $(document).on('click', '.cmb-tab', function() {
        if (!$(this).hasClass('cmb-tab--done')) return;
        window.editStep(parseInt($(this).data('step')));
    });

    // ── Back button ───────────────────────────────────────────────
    $(document).on('click', '.cmb-back-btn', function() {
        var t = parseInt($(this).data('target'));
        if (t === 3 && !_omslagEnabled) t = 2; // hverdag: Omslag yok → 2'ye dön
        window.editStep(t);
    });

    // ── Edit step ─────────────────────────────────────────────────
    window.editStep = function(n) {
        if (n === 3 && !_omslagEnabled) n = 2; // Omslag kapalı → adım 3'e gidilmez
        if (n === 1) {
            _prevBoxVariantId = $('#step1').attr('data-bundleproductvariantid') || '';
            var isReEdit = $.trim($('#step2-summary').html()) !== '';
            $('#step1-next-btn').text('Neste →');
            setActiveTab(1);
            showOnlyStep(1);

        } else if (n === 2) {
            $('.full-basket').hide();
            $('.step2-main1').css('pointer-events', 'unset');
            $('.step2-main21').css('pointer-events', 'unset');
            $('.step2-child .macron-qty-main').css('display', 'flex');
            $('.cross-icon-div').show();
            setActiveTab(2);
            showOnlyStep(2);

        } else if (n === 3) {
            setActiveTab(3);
            showOnlyStep(3);
            updateFooterBtn(3);
            var $selCover = $('.cover-box.selected-cover-box');
            if ($selCover.length > 0) {
                showOmslagPreviewBtn();
                var handle3 = $selCover.data('handle') || '';
                var fallback3 = $selCover.find('.card-img-d').attr('src') || '';
                if (handle3) showStep3Preview(handle3, fallback3);
            }

        } else if (n === 4) {
            setActiveTab(4);
            showOnlyStep(4);

        } else if (n === 5) {
            setActiveTab(5);
            showOnlyStep(5);

        } else if (n === 6) {
            setActiveTab(6);
            showOnlyStep(6);
        }
        price_calculate();
    };

    window.addEventListener('popstate', function(e) {
        if (_currentStep > 1) {
            _skipHistoryPush = true;
            window.editStep(prevStepOf(_currentStep) || (_currentStep - 1));
            _skipHistoryPush = false;
        }
    });

    // ── Modal (Omslag info) ───────────────────────────────────────
    $('#info-btn-omslag').on('click', function() { $('#omslag-info-modal').fadeIn(); });
    $('#close-info-modal').on('click', function() { $('#omslag-info-modal').fadeOut(); });
    $(document).mouseup(function(e) {
        var $mc = $(".modal-content");
        if (!$mc.is(e.target) && $mc.has(e.target).length === 0) $('#omslag-info-modal').fadeOut();
    });

    // ── Step 1: box selection ─────────────────────────────────────
    $(document).on('click', ".step1-child", function() {
        var $this = $(this);
        var alreadySelected = $this.hasClass('selected');

        if (alreadySelected) {
            $this.removeClass('selected');
            _boxQty = 0;
            $('#step1')
                .attr('data-bundleProductPrice', '0')
                .attr('data-bundleProductVariantId', '')
                .attr('data-bundleProductTitle', '')
                .attr('data-productbundlespace', '0');
            $('.step1-qty-inline').each(function() {
                $(this).removeClass('qty-visible');
                $(this).find('.step1-qty-val').hide().text('');
                $(this).find('.step1-qty-dec').hide();
                $(this).find('.step1-qty-inc').text('Velg').addClass('step1-qty-velg');
            });
            // Reset steps 2+
            $('.full-basket').hide();
            $('.step2-child .macron-qty-main').css('display', 'flex');
            $('.step2-c').attr('data-totalqty', '0');
            $(".macron-qty").each(function() { $(this).text(0); });
            $(".step2-child-selected").each(function() { $(this).addClass('choose-image').html(''); });
            $('.preset-card').removeClass('active');
            $(".cover_box_input, .greeting_card_input").prop('checked', false);
            $(".cover-box").removeClass("selected-cover-box");
            $(".greeting-card").removeClass("selected-card-box");
            $('#gift-message').val('');
            resetSummariesFrom(2);
            setOmslagEnabled(true); // seçim kalkınca Omslag adımını geri aç
            $('#postnummer-gate').removeClass('open');
            _postnummerOk = false;
            setActiveTab(1);
            updateFooterBtn(1);
            price_calculate();
            return;
        }

        $(".step1-child").removeClass("selected");
        $this.addClass("selected");
        var newId = $this.attr("data-variantid") || '';
        $('#step1').attr('data-bundleProductPrice',     $this.attr("data-price"));
        $('#step1').attr('data-bundleProductVariantId', newId);
        $('#step1').attr('data-bundleProductTitle',     $this.attr("data-title"));
        $('#step1').attr('data-productbundlespace',     $this.attr('data-bundlespace'));
        if (_minQtyGlobal === 0) _boxQty = 1; // retail: adet her zaman 1 (deselect 0'a düşürmüş olabilir → 0 kr bug'ı)

        // hverdag (tray) kartı Omslag adımını atlar; gaveeske kartlarında omslag açık
        var isHverdagCard = $this.attr('data-no-omslag') === '1';
        setOmslagEnabled(!isHverdagCard);
        // gaveeske → kutu seçimi popup açmaz; footer "Sjekk postnummer"e döner, kişi
        //            hazır olunca basıp modalı açar. Kutu değiştirince girilen kod silinmez.
        // hverdag → her yere gider, postnummer sorulmaz.

        // Firmagave: adet seçici — diğer kartlarda gizle ve sıfırla, seçilende göster
        if (_minQtyGlobal > 0) {
            var $qtyWrap = $this.find('.step1-qty-inline');
            // Diğer kartları sıfırla ve gizle
            $('.step1-qty-inline').not($qtyWrap).each(function() {
                $(this).removeClass('qty-visible');
                $(this).find('.step1-qty-val').hide().text('');
                $(this).find('.step1-qty-dec').hide();
                $(this).find('.step1-qty-inc').text('Velg').addClass('step1-qty-velg');
            });
            // Aynı karta tıklanmışsa sayacı sıfırlama
            if (!alreadySelected) {
                _boxQty = 0;
                $qtyWrap.find('.step1-qty-val').hide().text('');
                $qtyWrap.find('.step1-qty-dec').hide();
                $qtyWrap.find('.step1-qty-inc').text('Velg').addClass('step1-qty-velg');
            }
            $qtyWrap.addClass('qty-visible');
        }

        // Update footer button label based on re-edit + box-change state
        var step2Done = $.trim($('#step2-summary').html()) !== '';
        var isChange  = _prevBoxVariantId && newId !== _prevBoxVariantId;
        if (isChange && step2Done) {
            $('.full-basket').hide();
            $('.step2-child .macron-qty-main').css('display', 'flex');
            $('.step2-c').attr('data-totalqty', '0');
            $(".macron-qty").each(function() { $(this).text(0); });
            var spaces = parseInt($('#step1').attr('data-productbundlespace')) || 0;
            $('.step2-selected-c').html('');
            for (var i = 0; i < spaces; i++) {
                $('.step2-selected-c').append('<div class="step2-child-selected choose-image" style="cursor:unset"></div>');
            }
            $(".cover_box_input, .greeting_card_input").prop('checked', false);
            $(".cover-box").removeClass("selected-cover-box");
            $(".greeting-card").removeClass("selected-card-box");
            clearStep3Preview();
            $('#gift-message').val('');
            resetSummariesFrom(2);
            setActiveTab(1);
            updateFooterBtn(1);
        } else {
            updateFooterBtn(1);
        }
        price_calculate();
    });

    // ── Gaveeske: Oslo posta kodu kontrolü ───────────────────────
    $(document).on('input', '#postnummer-input', function () {
        var v = $(this).val().replace(/\D/g, '').slice(0, 4);
        if (v !== $(this).val()) $(this).val(v);
        var $msg = $('#postnummer-msg');
        if (v.length < 4) {
            _postnummerOk = false;
            $msg.text('').attr('class', 'postnummer-msg');
            $('#postnummer-switch').hide();
        } else if (isOsloPostnummer(v)) {
            _postnummerOk = true;
            $msg.html('✓ Vi leverer gaveeske til deg<br><span class="pn-nowrap">tirsdag eller torsdag, kl. 16–21</span>').attr('class', 'postnummer-msg postnummer-msg--ok');
            $('#postnummer-switch').hide();
        } else {
            _postnummerOk = false;
            $msg.text('Gaveesker sender vi kun i Oslo-området. Hverdagsbrett kommer perfekt frem til deg.').attr('class', 'postnummer-msg postnummer-msg--no');
            $('#postnummer-switch').show();
        }
        $('#postnummer-continue').prop('disabled', !_postnummerOk);
        updateFooterBtn(1);
    });
    $(document).on('keydown', '#postnummer-input', function (e) {
        if (e.key === 'Enter' && _postnummerOk) $('#postnummer-continue').click();
    });
    // Oslo kodu geçerli → modal kapanır, makaron adımına geçer
    $(document).on('click', '#postnummer-continue', function () {
        if (!_postnummerOk) return;
        $('#postnummer-gate').removeClass('open');
        $('#cmb-footer-next-btn').trigger('click');
    });
    // Oslo dışı kod → gaveeskeleri gizle, hverdag'a kaydır (kullanıcı tray'i kendi seçer)
    function setGaveVisible(on) {
        var $heading = $('.step1-gave-heading');
        var $cards   = $('.step1-c').not('.step1-c--hverdag');
        if (on) { $heading.show(); $cards.show(); $('#gave-unavailable').hide(); $('#step1').removeClass('gave-hidden'); }
        else    { $heading.hide(); $cards.hide(); $('#gave-unavailable').show(); $('#step1').addClass('gave-hidden'); }
    }
    $(document).on('click', '#postnummer-switch', function () {
        $('#postnummer-gate').removeClass('open');
        _postnummerOk = false;
        $('.step1-child.selected').not('.step1-child--hverdag').trigger('click'); // gaveeske seçimini temizle
        setGaveVisible(false);
        var el = document.querySelector('.step1-hverdag');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    // "Endre postnummer" → gaveeskeleri geri getir (yanlış kod yazıldıysa)
    $(document).on('click', '#gave-restore', function () {
        setGaveVisible(true);
        var el = document.querySelector('.step1-gave-heading');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    // Modalı aç (footer "Sjekk postnummer" → tıklanınca) — temiz giriş durumu
    function openPostnummerGate() {
        _postnummerOk = false;
        $('#postnummer-input').val('');
        $('#postnummer-msg').text('').attr('class', 'postnummer-msg');
        $('#postnummer-switch').hide();
        $('#postnummer-continue').prop('disabled', true);
        $('#postnummer-gate').addClass('open');
        setTimeout(function () { $('#postnummer-input').focus(); }, 120);
    }
    // Kapat (X / dış tıklama): kutu seçimi korunur; footer "Sjekk postnummer" kalır, kişi tekrar açabilir
    function closePostnummerGate() {
        $('#postnummer-gate').removeClass('open');
        updateFooterBtn(1);
    }
    $(document).on('click', '#postnummer-close', function () { closePostnummerGate(); });
    $(document).on('click', '#postnummer-gate', function (e) {
        if (e.target === this) closePostnummerGate();
    });

    // ── Firmagave: adet +/- ──────────────────────────────────────
    $(document).on('click', '.step1-qty-inc', function(e) {
        e.stopPropagation();
        var $btn = $(this);
        if (_boxQty < _minQtyGlobal) {
            _boxQty = _minQtyGlobal;
            $btn.text('+').removeClass('step1-qty-velg');
        } else {
            _boxQty++;
        }
        var $wrap = $btn.closest('.step1-qty-inline');
        $wrap.find('.step1-qty-val').show().text(_boxQty);
        $wrap.find('.step1-qty-dec').show().prop('disabled', _boxQty <= _minQtyGlobal);
        updateFooterBtn(1);
        price_calculate();
    });
    $(document).on('click', '.step1-qty-dec', function(e) {
        e.stopPropagation();
        if (_boxQty <= _minQtyGlobal) return;
        _boxQty--;
        var $wrap = $(this).closest('.step1-qty-inline');
        $wrap.find('.step1-qty-val').text(_boxQty);
        $wrap.find('.step1-qty-dec').prop('disabled', _boxQty <= _minQtyGlobal);
        updateFooterBtn(1);
        price_calculate();
    });

    // ── Footer next button (handles ALL steps) ────────────────────
    $('#cmb-footer-next-btn').on('click', function() {
        if ($(this).prop('disabled')) return;
        var step     = parseInt($('.cmb-tab--active').data('step'));
        var isReEdit = $(this).data('reedit');

        if (step === 1) {
            // gaveeske + kod henüz doğrulanmadıysa: ilerleme yerine postnummer modalını aç
            var $selBox   = $('.step1-child.selected');
            var isGaveBox = $selBox.length > 0 && $selBox.attr('data-no-omslag') !== '1';
            if (isGaveBox && !_postnummerOk) {
                openPostnummerGate();
                return;
            }
            var newVariantId  = $('.step1-child.selected').attr('data-variantid') || '';
            var boxChanged    = !_prevBoxVariantId || newVariantId !== _prevBoxVariantId;
            var step2HasState = $.trim($('#step2-summary').html()) !== '';
            $('#step1-summary').html('');
            showStep1Summary();
            _prevBoxVariantId = newVariantId;

            if (boxChanged || !step2HasState) {
                $(".macron-qty").each(function() { $(this).text(0); });
                $('.step2-c').attr('data-totalqty', '0');
                var spaces = parseInt($('#step1').attr('data-productbundlespace')) || 0;
                $(".step2-selected-c").html('');
                for (var i = 0; i < spaces; i++) {
                    $(".step2-selected-c").append('<div class="step2-child-selected choose-image" style="cursor:unset"></div>');
                }
                $('.full-basket').hide();
                $('.step2-main1').css('pointer-events', 'unset');
                $('.step2-main21').css('pointer-events', 'unset');
                $('.step2-child .macron-qty-main').css('display', 'flex');
                $('.cross-icon-div').show();
                resetSummariesFrom(2);
            }
            setActiveTab(2);
            showOnlyStep(2);

        } else if (step === 2) {
            showStep2Summary();
            if (!_omslagEnabled) {
                // hverdag: Omslag'ı atla — cover'ı "ingen" yap, doğrudan Kort'a (4) geç
                $('#no-thanks-cover').prop('checked', true).trigger('change');
                showStep3Summary('Ingen omslag', null);
                setActiveTab(4); showOnlyStep(4);
            } else {
                setActiveTab(3); showOnlyStep(3);
            }

        } else if (step === 3) {
            var hasCover = $('.cover-box.selected-cover-box').length > 0;
            if (hasCover) {
                showStep3Summary($('.selected-cover-box .step3-title').text() || 'Omslag', $('.selected-cover-box .card-img-d').attr('src') || null);
            } else {
                $('#no-thanks-cover').prop('checked', true).trigger('change');
                showStep3Summary('Ingen omslag', null);
            }
            setActiveTab(4); showOnlyStep(4);

        } else if (step === 4) {
            var hasCard = $('.greeting-card.selected-card-box').length > 0;
            if (hasCard) {
                showStep4Summary($('.selected-card-box .step3-title').text() || 'Kort', $('.selected-card-box .card-img-d').attr('src') || null);
            } else {
                $('#no-thanks-card').prop('checked', true).trigger('change');
                showStep4Summary('Ingen kort', null);
            }
            setActiveTab(5); showOnlyStep(5);

        } else if (step === 5) {
            var hasMsg = $.trim($('#gift-message').val()) !== '';
            showStep5Summary(hasMsg ? 'Melding lagt til' : 'Ingen melding');
            setActiveTab(6);
            showOnlyStep(6);
        }
        price_calculate();
    });

    // ── Step 3: cover filter ──────────────────────────────────────
    $(document).on('click', '.cover-filter-btn', function() {
        $('.cover-filter-btn').removeClass('active');
        $(this).addClass('active');
        // Clear cover selection when switching tema
        $('.cover-box').removeClass('selected-cover-box');
        $('.cover_box_input').prop('checked', false);
        clearStep3Preview();
        hideOmslagPreviewBtn();
        updateFooterBtn(3);
        price_calculate();
        var filter = $(this).data('filter');
        if (filter === 'all') {
            $('.cover-box').show();
        } else {
            $('.cover-box').each(function() {
                $(this).toggle(( $(this).data('tema') || '' ).indexOf(filter) !== -1);
            });
        }
    });

    // ── Step 3: cover selected ────────────────────────────────────
    $(document).on('click', '.cover-box', function(e) {
        if ($(e.target).is('.cover_box_input')) return;
        var $radio = $(this).find('.cover_box_input');
        if ($radio.is(':checked')) {
            $radio.prop('checked', false);
            $(this).removeClass('selected-cover-box');
            clearStep3Preview();
            hideOmslagPreviewBtn();
            updateFooterBtn(3);
            price_calculate();
            return false;
        }
    });
    $(document).on('change', '.cover_box_input', function() {
        if (!_omslagEnabled) { price_calculate(); return; } // sadece "ingen" radyosu var
        $(".cover-box").removeClass("selected-cover-box");
        var $label = $(this).parents(".cover-box");
        $label.addClass("selected-cover-box");
        var handle = $label.data('handle') || '';
        var fallback = $label.find('.card-img-d').attr('src') || '';
        if (handle) showStep3Preview(handle, fallback);
        showOmslagPreviewBtn();
        updateFooterBtn(3);
        price_calculate();
    });

    // ── Step 4: card selected ─────────────────────────────────────
    $(document).on('click', '.greeting-card', function(e) {
        if ($(e.target).is('.greeting_card_input')) return;
        var $radio = $(this).find('.greeting_card_input');
        if ($radio.is(':checked')) {
            $radio.prop('checked', false);
            $(this).removeClass('selected-card-box');
            updateFooterBtn(4);
            price_calculate();
            return false;
        }
    });
    $(".greeting_card_input").change(function() {
        $(".greeting-card").removeClass("selected-card-box");
        $(this).parents(".greeting-card").addClass("selected-card-box");
        updateFooterBtn(4);
        price_calculate();
    });

    // ── Reset basket (Start på nytt inside step 2) ────────────────
    $("#reset-btn").click(function() {
        $('.full-basket').hide();
        $('.step2-main1').css('pointer-events', 'unset');
        $('.step2-main21').css('pointer-events', 'unset');
        $('.step2-child .macron-qty-main').css('display', 'flex');
        $('.cross-icon-div').show();
        $('.step2-c').attr('data-totalqty', '0');
        $(".macron-qty").each(function() { $(this).text(0); });
        $(".step2-child-selected").each(function() { $(this).addClass('choose-image').html(''); });
        updateFooterBtn(2);
        price_calculate();
    });

    // ── Sammendrag: slett alle valg og begynn på nytt ────────────
    $('#cmb-reset-all-btn').on('click', function() {
        $('.full-basket').hide();
        $('.step2-main1').css('pointer-events', 'unset');
        $('.step2-main21').css('pointer-events', 'unset');
        $('.step2-child .macron-qty-main').css('display', 'flex');
        $('.cross-icon-div').show();
        $('#gift-message').val('');
        resetSummariesFrom(1);
        $(".cover_box_input").each(function() { $(this).prop('checked', false); });
        if (!_omslagEnabled) $('#no-thanks-cover').prop('checked', true);
        $(".macron-qty").each(function() { $(this).text(0); });
        $(".step2-child-selected").each(function() { $(this).addClass('choose-image').html(''); });
        $('.step2-c').attr('data-totalqty', '0');
        $(".greeting_card_input").each(function() { $(this).prop('checked', false); });
        $(".step1-child").removeClass("selected");
        _prevBoxVariantId = '';
        setActiveTab(1);
        showOnlyStep(1);
        price_calculate();
    });

    // ── Change box size (full reset to step 1) ────────────────────
    $("#change_box_size").click(function() {
        $('.full-basket').hide();
        $('.step2-main1').css('pointer-events', 'unset');
        $('.step2-main21').css('pointer-events', 'unset');
        $('.step2-child .macron-qty-main').css('display', 'flex');
        $('.cross-icon-div').show();
        $('#gift-message').val('');
        resetSummariesFrom(1);
        $(".cover_box_input").each(function() { $(this).prop('checked', false); });
        if (!_omslagEnabled) $('#no-thanks-cover').prop('checked', true);
        $(".macron-qty").each(function() { $(this).text(0); });
        $(".step2-child-selected").each(function() { $(this).addClass('choose-image').html(''); });
        $('.step2-c').attr('data-totalqty', '0');
        $(".greeting_card_input").each(function() { $(this).prop('checked', false); });
        $(".step1-child").removeClass("selected");
        _prevBoxVariantId = '';
        setActiveTab(1);
        showOnlyStep(1);
        price_calculate();
    });

    // ── Macaron decrement ─────────────────────────────────────────
    $(".macron-decrement").click(function() {
        var qty = parseInt($(this).next('.macron-qty').text());
        if (qty === 0) return;
        $(this).next('.macron-qty').text(qty - 1);
        var total = parseInt($('.step2-c').attr('data-totalqty')) - 1;
        $('.step2-c').attr('data-totalqty', total);
        var id    = $(this).parents(".step2-child").attr('data-ids');
        $('.cross-icon[data-crossid="' + id + '"]').last().parents('.step2-child-selected').addClass('choose-image').html('');
        updateFtrMacronStrip();
        updateFooterBtn(2);
        price_calculate();
    });

    // ── Macaron increment ─────────────────────────────────────────
    $(document).on('click', ".macron-increment", function(e) {
        e.preventDefault();
        var qty   = parseInt($(this).prev('.macron-qty').text());
        var total = parseInt($('.step2-c').attr('data-totalqty'));
        var max   = parseInt($('#step1').attr('data-productbundlespace'));

        if (total < max) {
            $('.step2-c').attr('data-totalqty', total + 1);
            $(this).prev('.macron-qty').text(qty + 1);
            var $product   = $(this).closest('.step2-child');
            var mName      = $product.find('.macron-name').text();
            var $emptySlot = $('.step2-child-selected').filter(function() {
                return $(this).find('img').length === 0;
            }).first();
            if ($emptySlot.length > 0) {
                $emptySlot.removeClass("choose-image").html(
                    '<div class="macron-temp-div" data-macronname="' + mName + '">'
                    + '<img class="card-img-e" alt="" src="' + $product.data('image') + '">'
                    + '<div class="cross-icon-div"><p data-crossid="' + $product.attr('data-id') + '" class="cross-icon">×</p></div>'
                    + '<p class="basket-macron-name">' + mName + '</p>'
                    + '</div>'
                );
            }
        }
        updateFtrMacronStrip();
        updateFooterBtn(2);
        if (total + 1 === max && window.innerWidth <= 640) flashKurvBtn();
        price_calculate();
    });

    $(document).on('click', ".macron-qty", function(e) { e.preventDefault(); });

    // ── Cross icon (remove macron from basket) ────────────────────
    $(document).on('click', ".cross-icon", function() {
        var id       = $(this).attr('data-crossid');
        var $cell    = $("[data-ids='" + id + "']");
        $cell.find('.macron-qty').text(parseInt($cell.find('.macron-qty').text()) - 1);
        var newTotal = parseInt($('.step2-c').attr('data-totalqty')) - 1;
        $('.step2-c').attr('data-totalqty', newTotal);
        $(this).parents('.step2-child-selected').addClass('choose-image');
        $(this).parents('.macron-temp-div').remove();
        var max = parseInt($('#step1').attr('data-productbundlespace')) || 0;
        if (newTotal < max) {
            $('.full-basket').hide();
            $('.step2-main1, .step2-main21').css('pointer-events', 'unset');
            $('.step2-child .macron-qty-main').css('display', 'flex');
            $('.cross-icon-div').show();
        }
        updateFtrMacronStrip();
        updateFooterBtn(2);
    });

    // ── Mobile: footer macaron strip (step 2) ────────────────────────
    function updateFades() {
        var el = document.getElementById('cmb-ftr-macron-strip');
        if (!el) return;
        var $wrap = $('#cmb-ftr-strip-wrap');
        $wrap.toggleClass('fade-left',  el.scrollLeft > 4);
        $wrap.toggleClass('fade-right', el.scrollLeft < el.scrollWidth - el.clientWidth - 4);
    }

    function updateFtrMacronStrip() {
        if (window.innerWidth > 640) return;
        var $strip = $('#cmb-ftr-macron-strip');
        var $count = $('#cmb-ftr-macron-count');
        var max    = parseInt($('#step1').attr('data-productbundlespace')) || 0;
        var total  = parseInt($('.step2-c').attr('data-totalqty')) || 0;
        $strip.empty();
        $('.macron-temp-div').each(function() {
            var src = $(this).find('img.card-img-e').attr('src') || '';
            if (src) $strip.append('<img class="ftr-macron-avatar" src="' + src + '" alt="">');
        });
        $count.text(total + ' / ' + max);
        setTimeout(updateFades, 30);
        if ($('#cmb-kurv-sheet').hasClass('open')) renderKurvSheet();
    }

    function ftrMacronsShow() {
        if (window.innerWidth <= 640) $('#cmb-footer-macrons').css('display', 'flex');
    }
    function ftrMacronsHide() { $('#cmb-footer-macrons').hide(); }

    // ── Bottom sheet: Din kurv ────────────────────────────────────────
    function renderKurvSheet() {
        var $content = $('#cmb-kurv-sheet-content');
        $content.empty();
        var total = parseInt($('.step2-c').attr('data-totalqty')) || 0;
        if (total === 0) {
            $content.html('<p class="kurv-sheet-empty">Ingen makroner valgt ennå.</p>');
            return;
        }
        var html = '<div class="kurv-sheet-grid">';
        $('.macron-temp-div').each(function() {
            var src     = $(this).find('img.card-img-e').attr('src') || '';
            var name    = $(this).data('macronname') || '';
            var crossId = $(this).find('.cross-icon').attr('data-crossid') || '';
            html += '<div class="kurv-sheet-item">'
                + '<div class="kurv-sheet-img-wrap">'
                + '<img src="' + src + '" alt="' + name + '">'
                + '<button type="button" class="kurv-sheet-remove" data-crossid="' + crossId + '">×</button>'
                + '</div>'
                + '<p class="kurv-sheet-name">' + name + '</p>'
                + '</div>';
        });
        html += '</div>';
        $content.html(html);
    }

    function openKurvSheet()  { renderKurvSheet(); $('#cmb-kurv-sheet-overlay, #cmb-kurv-sheet').addClass('open'); }
    function closeKurvSheet() {
        $('#cmb-kurv-sheet-overlay, #cmb-kurv-sheet').removeClass('open');
        setTimeout(function () { $('#cmb-kurv-sheet-content').empty(); }, 320);
    }

    $('#cmb-se-kurv-btn').on('click', openKurvSheet);
    $(document).on('click', '#cmb-ftr-strip-wrap', openKurvSheet);

    function flashKurvBtn() {
        var $btn = $('#cmb-se-kurv-btn');
        $btn.removeClass('kurv-btn--flash');
        void $btn[0].offsetWidth;
        $btn.addClass('kurv-btn--flash');
        setTimeout(function() { $btn.removeClass('kurv-btn--flash'); }, 3300);
    }
    $('#cmb-kurv-sheet-close, #cmb-kurv-sheet-overlay').on('click', closeKurvSheet);

    $(document).on('click', '.kurv-sheet-remove', function() {
        var crossId = $(this).data('crossid');
        $('.step2-child-selected .cross-icon[data-crossid="' + crossId + '"]').last().trigger('click');
    });

    // ── Gift message character counter ────────────────────────────
    $(document).on('keyup', '#gift-message', function() { price_calculate(); updateFooterBtn(5); });
    var giftMessage        = document.getElementById('gift-message');
    var remainingCharacters = document.getElementById('remaining-characters');
    giftMessage.addEventListener('input', function() {
        var max     = 200;
        var current = this.value.length;
        if (current > max) this.value = this.value.substring(0, max);
        remainingCharacters.textContent = (max - this.value.length) + ' tegn igjen';
    });

    // ── Incomplete step modal ─────────────────────────────────────
    var _incompleteStep = 0;
    $('#incomplete-step-overlay, #incomplete-step-go').on('click', function() {
        $('#incomplete-step-modal').fadeOut(200);
        if ($(this).is('#incomplete-step-go') && _incompleteStep) {
            window.editStep(_incompleteStep);
        }
    });

    // ── Add to cart ───────────────────────────────────────────────
    $(document).on('click', '#add_box_to_card', function() {
        var stepLabels = {
            1: 'Velg boks (steg 1)', 2: 'Velg makroner (steg 2)',
            3: 'Velg omslag (steg 3)', 4: 'Velg hilsenkort (steg 4)', 5: 'Legg til melding (steg 5)'
        };
        var incomplete = 0;
        for (var s = 1; s <= 5; s++) {
            if (!$('#step' + s + '-summary').length || $.trim($('#step' + s + '-summary').html()) === '') {
                incomplete = s; break;
            }
        }
        if (incomplete) {
            _incompleteStep = incomplete;
            $('#incomplete-step-msg').text(stepLabels[incomplete] + ' er ikke fullført. Gå tilbake og fullfør dette steget for å legge i kurven.');
            $('#incomplete-step-modal').fadeIn(200);
            return;
        }

        $(".container-c2").show();
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
        })
        .then(function() {
            $(".container-c2").hide();
            if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
                window.CartDrawer.open();
            } else {
                window.location.href = '/cart';
            }
        })
        .catch(function(error) {
            $(".container-c2").hide();
            console.error('Error:', error);
        });
    });

    // ── Macaron info modal ────────────────────────────────────────
    $(document).on('click', '.card-img-e', function() {
        if ($(this).closest('.step2-child-selected').length > 0) return;
        var $t = $(this);
        $('.modal-macron-img').attr('src', $t.attr('data-image'));
        $('.modal-macron-text').text($t.attr('data-name'));
        $('.modal-macron-description').text($t.attr('data-description'));
        $('.ingredient-p').text($t.attr('data-ingredient'));
        $('.allergy-p').text($t.attr('data-allergy'));
        $('.overlay').css({ display: 'flex', opacity: 0 }).animate({ opacity: 1 }, 400);
    });

    $('.close-btn').click(function() { $('.overlay').fadeOut(); });

    $(document).on('click', '.accordion-header', function() {
        var $action = $(this).find('.data-action-c');
        $action.text($action.text() === '+' ? '-' : '+');
        $(this).next('.accordion-collapse').toggleClass('show');
        $(this).toggleClass('collapsed');
    });

    // ── Macaron summary grid ──────────────────────────────────────
    function renderMacronSummary() {
        var isMobile = window.innerWidth <= 640;
        var html = '';
        if (isMobile) {
            var counts = {}, imgs = {}, order = [];
            $('.macron-temp-div').each(function() {
                var name = $(this).data('macronname') || '';
                var src  = $(this).find('img').attr('src') || '';
                if (!name) return;
                if (!counts[name]) { counts[name] = 0; imgs[name] = src; order.push(name); }
                counts[name]++;
            });
            if (!order.length) { $('#macron-summary-section').hide(); return; }
            order.forEach(function(name) {
                html += '<div class="macron-sum-card">'
                      + '<div class="macron-sum-img-wrap">'
                      + '<img class="macron-sum-img" src="' + imgs[name] + '" alt="' + name + '">'
                      + (counts[name] > 1 ? '<span class="macron-sum-qty">×' + counts[name] + '</span>' : '')
                      + '</div>'
                      + '<p class="macron-sum-name">' + name + '</p>'
                      + '</div>';
            });
        } else {
            $('.macron-temp-div').each(function() {
                var name = $(this).data('macronname') || '';
                var src  = $(this).find('img').attr('src') || '';
                if (!name) return;
                html += '<div class="macron-sum-card">'
                      + '<div class="macron-sum-img-wrap">'
                      + '<img class="macron-sum-img" src="' + src + '" alt="' + name + '">'
                      + '</div>'
                      + '<p class="macron-sum-name">' + name + '</p>'
                      + '</div>';
            });
        }
        if (!html) { $('#macron-summary-section').hide(); return; }
        $('#macron-summary-grid').html(html);
        $('#macron-summary-section').show();
    }

    // ── Price calculation ─────────────────────────────────────────
    var items = [];

    function price_calculate() {
        items = [];
        var cover_box_id         = '';
        var greeting_card_id     = '';
        var message              = '';
        var selected_bundle_id   = '';
        var resultArray          = [];

        var greeting_card_price = parseFloat($('.greeting_card_input[type="radio"]:checked').attr('data-price') || 0);
        var gift_box_price      = parseFloat($('.cover_box_input[type="radio"]:checked').attr('data-price') || 0);
        var bundle_price        = parseFloat($('#step1').attr('data-bundleproductprice') || 0);
        var total_price         = (greeting_card_price + gift_box_price + bundle_price) * _boxQty;

        var stripItems = [];
        var boxImg   = $('.step1-child.selected').attr('data-image') || '';
        var boxTitle = $('#step1').attr('data-bundleproducttitle') || '';
        if (boxTitle) stripItems.push({ img: boxImg, title: boxTitle, price: bundle_price });

        var coverVal = $('.cover_box_input[type="radio"]:checked').val();
        if (coverVal && coverVal !== 'no') {
            stripItems.push({
                img:   $('.selected-cover-box .card-img-d').attr('src') || '',
                title: $('.selected-cover-box .step3-title').text() || 'Omslag',
                price: gift_box_price
            });
        }

        var cardVal = $('.greeting_card_input[type="radio"]:checked').val();
        if (cardVal && cardVal !== 'no') {
            stripItems.push({
                img:   $('.selected-card-box .card-img-d').attr('src') || '',
                title: $('.selected-card-box .step3-title').text() || 'Kort',
                price: greeting_card_price
            });
        }

        if ($.trim($('#gift-message').val()) !== '') {
            stripItems.push({ type: 'message', title: 'Melding', price: 'Gratis' });
        }

        var msgIconSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>';
        var stripHtml = '';
        stripItems.forEach(function(item, i) {
            if (i > 0) stripHtml += '<span class="summary-sep">+</span>';
            var mediaHtml = item.type === 'message'
                ? '<div class="summary-img-wrap summary-icon-wrap">' + msgIconSvg + '</div>'
                : (item.img ? '<div class="summary-img-wrap"><img class="summary-img" src="' + item.img + '" alt=""></div>' : '');
            var priceHtml = item.type === 'message'
                ? '<p class="summary-item-price summary-gratis">Gratis</p>'
                : '<p class="summary-item-price">' + item.price.toFixed(0) + ',-</p>';
            stripHtml += '<div class="summary-item">' + mediaHtml + '<p class="summary-item-title">' + item.title + '</p>' + priceHtml + '</div>';
        });
        if (stripItems.length) {
            stripHtml += '<div class="summary-eq-block">'
                + '<span class="summary-sep">=</span>'
                + '<div class="summary-total-block">'
                + '<p class="summary-total-label">Totalt</p>'
                + '<p class="summary-total-price">' + total_price.toFixed(0) + ' kr</p>'
                + '</div>'
                + '</div>';
        }
        $('#order-summary-strip').html(stripHtml);
        // gaveeske → Oslo bud teslimat notu; hverdag (tray) ülke geneli → not yok
        $('#summary-delivery-note').toggle(!!_omslagEnabled && stripItems.length > 0);

        selected_bundle_id = $('#step1').attr('data-bundleproductvariantid');
        var macronNameCount = {};
        $('.macron-temp-div').each(function() {
            var name = $(this).data('macronname');
            macronNameCount[name] = (macronNameCount[name] || 0) + 1;
        });
        $.each(macronNameCount, function(name, count) { resultArray.push(count + ' x ' + name); });

        message = $('#gift-message').val();
        var properties = {};
        resultArray.forEach(function(el, i) { properties["Makron#" + (i + 1)] = el; });

        greeting_card_id = $('.greeting_card_input[type="radio"]:checked').val();
        var messageEl = document.getElementById('dynamic-message');
        if (messageEl) {
            messageEl.textContent = greeting_card_id === 'no'
                ? "Meldingen din vil bli skrevet på en etikett og lagt i boksen, helt gratis."
                : "Meldingen din vil bli skrevet på baksiden av kortet du har valgt.";
        }
        properties["Gift Message"] = message;
        cover_box_id     = $('.cover_box_input[type="radio"]:checked').val();
        greeting_card_id = $('.greeting_card_input[type="radio"]:checked').val();

        if (selected_bundle_id !== undefined) items.push({ id: selected_bundle_id, quantity: _boxQty, properties: properties });
        if (greeting_card_id !== undefined && greeting_card_id !== 'no') items.push({ id: greeting_card_id, quantity: _boxQty, properties: { 'Gift Message': message || '' } });
        if (cover_box_id !== undefined && cover_box_id !== 'no') items.push({ id: cover_box_id, quantity: _boxQty });
    }

    // ── Step 3: fetch second images for preview cache ─────────────
    function shopifyHiRes(src) {
        return src.replace(/(\.[a-z]+)(\?|$)/i, '_2048x$1$2');
    }

    function fetchStep3Variants() {
        $.getJSON('/products.json?limit=250', function (data) {
            (data.products || []).forEach(function (p) {
                if (p.handle && p.images && p.images.length > 1) {
                    var arr = [];
                    for (var i = 1; i <= 3; i++) {
                        var img = p.images[i];
                        if (!img) break;
                        var src = (typeof img === 'object' && img.src) ? img.src : img;
                        arr.push({ url: shopifyHiRes(src), type: 'image' });
                    }
                    if (arr.length) _previewCache[p.handle] = arr;
                }
            });
            fetchCoverVideos();
        });
    }

    function fetchCoverVideos() {
        $('.cover-box[data-handle]').each(function () {
            var handle = $(this).data('handle');
            if (!handle) return;
            var small  = $(this).data('video-small')  || '';
            var medium = $(this).data('video-medium') || '';
            var large  = $(this).data('video-large')  || '';
            if (small || medium || large) {
                _previewCache[handle] = [
                    { url: small  || medium || large, type: 'video' },
                    { url: medium || small  || large, type: 'video' },
                    { url: large  || medium || small, type: 'video' }
                ];
            }
        });
    }

    // ── Initialise ────────────────────────────────────────────────
    // Sort step1 box cards by price ascending — her container kendi içinde
    // (gave ve hverdag ayrı .step1-c'ler; tek tek sıralanmazsa appendTo kartları
    //  her iki container'a klonlar → her başlıkta tüm ürünler görünür)
    $('.step1-c').each(function () {
        var $c = $(this);
        $c.find('.step1-child').sort(function (a, b) {
            return parseFloat($(a).data('price')) - parseFloat($(b).data('price'));
        }).appendTo($c);
    });

    var _stripEl = document.getElementById('cmb-ftr-macron-strip');
    if (_stripEl) _stripEl.addEventListener('scroll', updateFades, { passive: true });
    if (_omslagEnabled) {
        fetchStep3Variants();
        $('.cover-filter-btn').first().trigger('click');
    } else {
        // Omslag kapalı: sekmeyi gizle + numaraları kaydır, cover'ı "ingen" olarak sabitle
        setOmslagEnabled(false);
        $('#no-thanks-cover').prop('checked', true);
    }
    updateFooterBtn(1);
    $('#cmb-footer-bar').show();
    history.replaceState({ wizardBase: true }, '');

    setTimeout(function() {
        if (window.innerWidth <= 640) {
            var tabTop = $('#cmb-tabs').offset().top;
            $('html, body').animate({ scrollTop: Math.max(0, tabTop - 20) }, 500);
        } else {
            var step1Top = $('#step1').offset().top;
            $('html, body').animate({ scrollTop: Math.max(0, step1Top - 30) }, 500);
        }
    }, 300);

});
